import steps from "./steps";
class processId {
  constructor(
    id,
    name,
    description,
    type,
    concept,
    steps,
  
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.type = type;
    this.concept = concept;
    this.steps = steps;
   
  }
  static fromJson({
    procesoId,
    nombre,
    descripcion,
    tipo,
    conceptoId,
    pasos
  
  }) {
    return new processId(
      procesoId,
      nombre,
      descripcion,
      tipo,
      conceptoId,
      pasos?.map((step)=>steps.fromJson(step))
   
    );
  }
}
export default processId;
